jQuery(function($) {
    const hotspotHoverList = $('.dipi_image_hotspot .dipi-image-hotspot:not(.dipi-trigger_on_click-on) .dipi-image-hotspot-child');
    var mouseEntered = false;
    var i
    function dipi_imagehotspot_show_tooltop(tooltip_element) {
        const dipi_image_hotspot_child_element = tooltip_element.closest('.dipi_image_hotspot_child')
        tooltip_element.style.display = 'inline-block'
        dipi_image_hotspot_child_element.classList.add("dipi-tooltip-on-top")

    }
    function dipi_imagehotspot_hide_tooltop(tooltip_element) {
        const dipi_image_hotspot_child_element = tooltip_element.closest('.dipi_image_hotspot_child')
        tooltip_element.style.display = 'none'
        dipi_image_hotspot_child_element.classList.remove("dipi-tooltip-on-top")

    }
    hotspotHoverList.on('mouseenter', function(event) 
        {
            if (event.relatedTarget && event.relatedTarget.classList.contains("dipi-tooltip-wrap")) {
                //return false;
            }
            //handlerIn
            const tooltip_element = this.parentElement.querySelector('.dipi-tooltip-wrap')
            if (tooltip_element) {
                dipi_imagehotspot_show_tooltop(tooltip_element)
            }
            event.stopPropagation()
            mouseEntered = true;
        }
    );
   
    hotspotHoverList.on('mouseleave', function(event) 
        {
            if (event.relatedTarget && event.relatedTarget.classList.contains("dipi-tooltip-wrap")) {
                //return false;
            }
            //handlerIn
            const tooltip_element = this.parentElement.querySelector('.dipi-tooltip-wrap')
            if (tooltip_element) {
                dipi_imagehotspot_hide_tooltop(tooltip_element)
            }
            event.stopPropagation()
            mouseEntered = false
        }
    );
    $(window).mousedown(function(e) {
        if (mouseEntered) {
            return
        }
        const tooltipList = document.querySelectorAll('.dipi_image_hotspot .dipi-image-hotspot .dipi-image-hotspot-child .dipi-tooltip-wrap');
        const tooltipList_len = tooltipList.length
        for ( i = 0; i < tooltipList_len; i++) {
            dipi_imagehotspot_hide_tooltop(tooltipList[i])
        }
    });
    const hotspotClickList = document.querySelectorAll('.dipi_image_hotspot .dipi-image-hotspot.dipi-trigger_on_click-on .dipi-image-hotspot-child .dipi-hotspot');
    const hotspotClickList_len = hotspotClickList.length
    var i
    for ( i = 0; i < hotspotClickList_len; i++) {
        hotspotClickList[i].addEventListener('click', function(event)
            { //handlerIn
                const tooltip_element = this.parentElement.querySelector('.dipi-tooltip-wrap')
                let element_display = true;
                if (tooltip_element && tooltip_element.style.display === 'inline-block') {
                    element_display = false
                } else {
                    element_display = true
                }
                const tooltipList = document.querySelectorAll('.dipi_image_hotspot .dipi-image-hotspot.dipi-trigger_on_click-on .dipi-image-hotspot-child .dipi-tooltip-wrap');
                const tooltipList_len = tooltipList.length
                for (var k = 0; k < tooltipList_len; k++ ) {
                    dipi_imagehotspot_hide_tooltop(tooltipList[k])
                }
                if (element_display) {
                    //tooltip_element.replaceWith(tooltip_element.clone().css('visibility', 'visible'))
                    dipi_imagehotspot_show_tooltop(tooltip_element)
                }

                mouseEntered = true // To fix issue of hiding overlay
                setTimeout(
                    function() {
                        mouseEntered = false // To make clicking out of popup should close popup.
                    }, 500);
                event.stopPropagation()
            }
        )
    }
})

